import React from 'react';
import * as S from './styles';

export default function FeatureFilter() {
	return (
		<S.container>
			<h1>FeatureFilter</h1>
		</S.container>
	);
}
